import * as React from 'react';


function PageContent({ children }) {
  return (
    <div className="app__cont">
      {children}
    </div>
  );
}

export default PageContent as any;
